import { RiCarouselView } from "react-icons/ri";
import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Pages Slider",
  name: "pageSlider",
  type: "object",
  icon: RiCarouselView,
  fields: [
    {
      name: "sectionLayoutConfig",
      type: "sectionLayoutConfig",
      title: "Section Layout",
      options: {
        collapsed: true,
        collapsable: true
      }
    },
    {
      name: "heading",
      title: "Heading",
      type: "sectionTitle"
    },
    {
      name: "items",
      title: "Slides",
      type: "array",
      of: [
        {
          type: "reference",
          to: { type: "page" }
        }
      ]
    }
  ],
  preview: {
    select: {
      title: "heading.title",
      items: "items"
    },
    prepare({ title, items }) {
      return {
        title: multilingualStringPreview(title) || "([Pages] Slider)",
        subtitle: `${items.length} items`
      };
    }
  }
});
